import React, { FC } from 'react';
import { Icon, IconProps } from '@chakra-ui/react';

export const Minus: FC<IconProps> = props => (
  <Icon {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.643 11.069C3.291 11.193 3 11.614 3 12c0 .242.119.521.299.701.325.325-.443.299 8.701.299s8.376.026 8.701-.299a.984.984 0 000-1.402c-.325-.326.446-.299-8.718-.296-7.286.003-8.182.01-8.34.066z"
      fill="currentColor"
    />
  </Icon>
);

Minus.displayName = 'MinusIcon';
